import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button, Popup, Icon, Table, Label } from 'semantic-ui-react';
import { ITechnicianCertificate } from '../../../app/models/techniciancertificate';
import EmployeeCertificateStore from '../../../app/stores/employeecertificateStore';
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';

const EmployeeCertificateCreateForm: React.FC<RouteComponentProps> = ({
  match,
  history
}) => {
  const employeecertificateStore = useContext(EmployeeCertificateStore);
  const {
    createEmployeeCertificate,
    submitting,
    loadCertificates,
    certificatesByName,
  } = employeecertificateStore;

  useEffect(() => {
    loadCertificates();
  }, []);

  const [employeecertificate, setEmployeeCertificate] = useState<ITechnicianCertificate>({
    id: '',
    createdAt: '',
    updatedAt: '',
    technicianEmail: '',
    certificateId: '',
    expiryDate: '',
    verified: 'N',
    remark: ''
  });

  const certificateOptions = certificatesByName.map(function (cert) {
    var option = { "key": cert.id, "text": cert.name, "value": cert.id }
    return option;
  }
  );

  const handleSubmit = () => {
    createEmployeeCertificate(employeecertificate).then(() => history.push(`/employeeportal/certificate`));
  };


  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setEmployeeCertificate({ ...employeecertificate, [name]: value });
  };

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Select
          label={<div>  
            <span style={{ fontWeight: 'bold' }}> Certificate* &nbsp;&nbsp;  </span>
            <Popup
              content={<Table compact unstackable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Category</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {certificatesByName.map(certificate => (
                    <Table.Row key={certificate.id}>
                      <Table.Cell>
                        <Label>{certificate.name}</Label>
                      </Table.Cell>
                      <Table.Cell>{certificate.category}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>}
              on='click'
              pinned
              wide='very'
              trigger={<Icon size='large' name='info circle' color='grey' />}
            /></div>}
          required
          onChange={(e, { name, value }) => setEmployeeCertificate({ ...employeecertificate, [name]: value })}
          options={certificateOptions}
          search
          name='certificateId'
          placeholder='Certificate'
          value={employeecertificate.certificateId}
        />

        <Form.Input
          label='Expiry Date'
          onChange={handleInputChange}
          name='expiryDate'
          type='date'
          placeholder='Expiry Date'
          value={employeecertificate.expiryDate}
        />
        <Form.Input
          label='Remark'
          onChange={handleInputChange}
          name='remark'
          placeholder='Remark'
          value={employeecertificate.remark}
        />
        <Button
          loading={submitting}
          floated='right'
          positive
          type='submit'
          content='Submit'
        />
        <Button
          onClick={() => history.push('/employeeportal/certificate')}
          floated='right'
          type='button'
          content='Cancel'
        />
      </Form>
    </Segment>
  );
};

export default observer(EmployeeCertificateCreateForm);
